import { connect } from 'react-redux';
import { goToEdit } from '../../ManageServices.saga';
import { selectSelectedResource } from '../Resources.selectors';
import ResourceDetails from './ResourceDetails';

const mapStateToProps = state => ({
  resource: selectSelectedResource(state),
});

const mapDispatchToProps = {
  handleEditClick: goToEdit,
};

export default connect(mapStateToProps, mapDispatchToProps)(ResourceDetails);
